export const ENDPOINT_ONE_HUB_BACKEND = 'one-hub-vw-1.0';

//MATCH_PERSON
export const ENDPOINT_MATCH_PERSON_HAS_PERSON = '/has-person';

// PARAMS
export const PARAM_IDENTITYKIT = 'identitykitId';
export const PARAM_VIN = 'vin';

//BONUS
export const ENDPOINT_MY_BONUS = 'one-hub-vw-1.0/my-benefits/bonus';
export const ENDPOINT_MY_BONUS_GARAGE = 'one-hub-vw-1.0/my-benefits/bonus/garage';

//VEHICLES
export const ENDPOINT_VEHICLES = 'one-hub-vw-1.0/vehicles'; //[GET]
export const ENDPOINT_CREATE_VEHICLE = 'one-hub-vw-1.0/vehicle/create'; //[POST] params: frame, license, comercialDenomination, modelYear, typeDescription, technicalSpecs(imagen, pdf), drivinfLicense (imagen, pdf)
export const ENDPOINT_DELETE_VEHICLE = 'one-hub-vw-1.0/vehicle/delete'; //[DELETE] body: {frame: 'XXXX'}
export const ENDPOINT_CONFIRM_VEHICLE = 'one-hub-vw-1.0/vehicle/confirm'; //[PATCH] body: {frame: 'XXXX'}

//DATA-COLLECTIONS
export const ENDPOINT_DATA_COLLECTION = 'one-hub-vw-1.0/data-collection'; //[GET]
export const ENDPOINT_NEW_ANSWER = 'one-hub-vw-1.0/data-collection/new-answer'; //[POST] body: {answers: 'XXXX'}

//Nuevos endpoints
export const ENDPOINT_GET_PERSON = 'one-hub-vw-1.0/person'; //[GET]
export const ENDPOINT_CREATE_PERSON = 'one-hub-vw-1.0/person/create'; //[POST]
export const ENDPOINT_ACCEPT_PERSON = 'one-hub-vw-1.0/person/clubvw/accept'; //[POST]
export const ENDPOINT_REJECT_PERSON = 'one-hub-vw-1.0/person/clubvw/reject'; //[POST]
export const ENDPOINT_CONSENTS_PERSON = 'one-hub-vw-1.0/person/clubvw/consents'; //[POST]

///////////////////////////////
// ENDPOINTS MAINTENACE PLAN //
///////////////////////////////
export const ENDPOINT_NEXT_OPERATIONS = '/next-operations?years=0&kms=0&model=all';
export const ENDPOINT_MY_MAINTENANCE_PLAN = '/my-maintenace-plan';
export const ENDPOINT_UPDATE_MY_KM = '/update-kms';
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS = '/new-operation-unofficial-installation';
export const ENDPOINT_KDNRS = '/kdnrs';
export const ENDPOINT_OPERATION_CATEGORIES = '/kdnrs-category';
export const ENDPOINT_MATCH_VEHICLE = '/match-vehicle';
export const ENDPOINT_HAS_VEHICLE = '/has-vehicle';

//IDENTITY KIT ENDPOINT/S
export const ENDPOINT_IK_CUSTOMER = '/v3/customers/';
export const ENDPOINT_IK_PERSONAL_DATA = '/personalData';

//MATCH_PERSON
export const ENDPOINT_UPDATE_MY_KM_FRAME_PARAM = 'frame';
export const ENDPOINT_UPDATE_MY_KM_FRAME_KMS = 'kms';

// UNOFFICIAL_OPERATIONS PARAMS
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_FRAME_PARAM = 'frame';
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_KMS_PARAM = 'kms';
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_DATE_PARAM = 'date';
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_LOCATION_PARAM = 'location';
export const ENDPOINT_NEW_UNOFFICIAL_OPERATIONS_ENTRYREASON_PARAM = 'entryReason';
